import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetAgentQueryParams {
  id: number;
}

export const getAgent = async (
  props: QueryProps<GetAgentQueryParams>
): Promise<NewUser> => {
  const res = await api.client.get(`/agents-new/${props.params.id}`, {
    signal: props.signal,
  });
  return res.data;
};
